package org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_product_general

import androidx.compose.runtime.Composable
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import org.hs_soft.runmynesto.domain.util.helper.Strings

enum class AppConstantsEnum(
    val id: String,
    val value: String
) {
    VAT_NORMAL(id = "1", value = "normal"),
    VAT_REDUCED(id = "2", value = "reduced"),
    VAT_FREE(id = "3", value = "free"),
    VAT_SPECIAL(id = "4", value = "special");

    @Composable
    fun getLabel(): String {
        val strings = Strings.current()
        return when (this) {
            VAT_NORMAL -> strings.vatNormal
            VAT_REDUCED -> strings.vatReduced
            VAT_FREE -> strings.vatFree
            VAT_SPECIAL -> strings.vatSpecial
        }
    }

    val label: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                VAT_NORMAL -> strings.vatNormal
                VAT_REDUCED -> strings.vatReduced
                VAT_FREE -> strings.vatFree
                VAT_SPECIAL -> strings.vatSpecial
            }
        }
}